import _createForOfIteratorHelper from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { SubjectSubscription } from "./Utils";
/** Stream implementation to stream items to the server. */

export var Subject = /*#__PURE__*/function () {
  function Subject() {
    _classCallCheck(this, Subject);

    this.observers = [];
  }

  _createClass(Subject, [{
    key: "next",
    value: function next(item) {
      var _iterator = _createForOfIteratorHelper(this.observers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observer = _step.value;
          observer.next(item);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "error",
    value: function error(err) {
      var _iterator2 = _createForOfIteratorHelper(this.observers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var observer = _step2.value;

          if (observer.error) {
            observer.error(err);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      var _iterator3 = _createForOfIteratorHelper(this.observers),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var observer = _step3.value;

          if (observer.complete) {
            observer.complete();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(observer) {
      this.observers.push(observer);
      return new SubjectSubscription(this, observer);
    }
  }]);

  return Subject;
}();